<script setup lang="ts">
import { computed, ref } from "vue";
import SidebarMenu from "./components/SidebarMenu.vue";
import TopBar from "./components/TopBar.vue";
import NoticePopup from "./components/NoticePopup.vue";
import BizInfoBanner from "./components/BizInfoBanner.vue";
import UpdateToast from "./components/UpdateToast.vue";

import { useRoute } from "vue-router";

const route = useRoute();

// 로그인 페이지 여부 확인
const isLoginPage = computed(() => route.name === "SignIn");

// 전체화면(사이드바/상단바 없이) 렌더할 페이지 — 인쇄용 등
const isBare = computed(() => isLoginPage.value || route.meta.fullscreen === true);

// 모바일 메뉴 상태
const mobileMenuOpen = ref(false);

// 메뉴 클릭 시 모바일 drawer 닫기
const handleMenuClick = () => {
  mobileMenuOpen.value = false;
};
</script>

<template>
  <div class="flex flex-col h-screen">
    <!-- 배포 후 stale chunk 감지 시 새로고침 안내(전역, 모든 페이지 공통) -->
    <UpdateToast />
    <div v-if="!isBare" class="relative flex h-screen">
      <!-- 모바일 오버레이 -->
      <div
        v-if="mobileMenuOpen"
        class="fixed inset-0 bg-black/50 z-30 lg:hidden"
        @click="mobileMenuOpen = false"
      ></div>

      <!-- 사이드바 -->
      <aside
        class="fixed lg:static inset-y-0 left-0 z-40 w-64 bg-gray-100 transform transition-transform duration-300 ease-in-out lg:translate-x-0 overflow-y-auto"
        :class="mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'"
      >
        <SidebarMenu @menu-click="handleMenuClick" />
      </aside>

      <!-- 메인 컨텐츠 -->
      <div class="flex-1 flex flex-col h-screen overflow-hidden">
        <!-- 상단 바 with 햄버거 버튼 (고정) -->
        <TopBar class="shrink-0">
          <template #hamburger>
            <button
              class="btn btn-ghost btn-circle lg:hidden"
              aria-label="메뉴 열기"
              @click="mobileMenuOpen = !mobileMenuOpen"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </template>
        </TopBar>

        <!-- 원장 계정: 상호명·사업자등록증 미입력 시 상단 고정 배너로 입력 유도 -->
        <BizInfoBanner class="shrink-0" />

        <!-- 메인 컨텐츠 영역 (이 영역만 스크롤) -->
        <main class="flex-1 p-2 bg-white overflow-auto">
          <router-view />
        </main>
      </div>

      <!-- 로그인 시 최신 일반공지(팝업 지정) 모달 -->
      <NoticePopup />
    </div>

    <!-- 로그인 페이지 -->
    <div v-else class="flex-1 overflow-auto">
      <router-view />
    </div>
  </div>
</template>
